import posthog from 'posthog-js';

import { isProductionEnvironment } from './env';

if (isProductionEnvironment()) {
  posthog.init('phc_X8hPllx6pfoVicBZn2LiLBhDmzGUMFHDEeg6yeISPOj', {
    api_host: 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
  });
}
